__turbopack_context__.v({
  "button": "coalMineCanary-module-scss-module__lqrK-G__button" + " " + __turbopack_context__.i(693367)["block"],
  "complete": "coalMineCanary-module-scss-module__lqrK-G__complete" + " " + __turbopack_context__.i(693367)["complete"],
  "medium": "coalMineCanary-module-scss-module__lqrK-G__medium" + " " + __turbopack_context__.i(693367)["medium"],
  "playing": "coalMineCanary-module-scss-module__lqrK-G__playing" + " " + __turbopack_context__.i(693367)["playing"],
  "small": "coalMineCanary-module-scss-module__lqrK-G__small" + " " + __turbopack_context__.i(693367)["small"],
});
